(() => {
  'use strict';
  const key = 'virtatarvike.vehicle.v1';
  const param = 'filter.p.m.vtf.fitment_groups';
  const carKeys = ['3-old','3-highland','y-old','y-juniper','s-old','s-refresh','x-old','x-refresh'];
  let saved = null;
  try { saved = JSON.parse(localStorage.getItem(key)); } catch (_) { /* Storage may be disabled. */ }
  const selectors = [...document.querySelectorAll('[data-vt-vehicle]')];
  const optionFor = value => selectors.flatMap(el => [...el.querySelectorAll('[data-vt-car] option')]).find(o => o.value === value);
  if (!saved || !carKeys.includes(saved.key) || (saved.year && (!Number.isInteger(+saved.year) || +saved.year < 2012 || +saved.year > new Date().getFullYear()+1))) saved = null;
  const oldGenerationLabels = {
    fi: {3:'ennen Highlandia',y:'ennen Juniperia',s:'ennen Refreshiä',x:'ennen Refreshiä'},
    en: {3:'before Highland',y:'before Juniper',s:'before Refresh',x:'before Refresh'},
    sv: {3:'före Highland',y:'före Juniper',s:'före Refresh',x:'före Refresh'},
    nl: {3:'vóór Highland',y:'vóór Juniper',s:'vóór Refresh',x:'vóór Refresh'},
    da: {3:'før Highland',y:'før Juniper',s:'før Refresh',x:'før Refresh'}
  };
  const carLabel = () => {
    const option = optionFor(saved?.key);
    if (option) return option.textContent.trim();
    if (!saved) return '';
    const [family, generation] = saved.key.split('-');
    const locale = document.documentElement.lang.toLowerCase().split('-')[0];
    const labels = oldGenerationLabels[locale] || oldGenerationLabels.en;
    const version = generation === 'old' ? labels[family] : ({3:'Highland',y:'Juniper',s:'Refresh',x:'Refresh'})[family];
    return 'Tesla Model '+family.toUpperCase()+' · '+version;
  };
  const activeFilters = [...new Set(new URLSearchParams(location.search).getAll(param))];
  const activeFilter = activeFilters.length === 1 ? activeFilters[0] : null;
  const activeOption = selectors.flatMap(el => [...el.querySelectorAll('[data-vt-car] option')]).find(o => o.dataset.filter === activeFilter);
  // Explicit URL selection wins over a different previously saved model.
  if (activeOption && activeOption.value !== saved?.key) saved = {key:activeOption.value,year:'',label:activeOption.textContent.trim()};
  function persist() { try { saved ? localStorage.setItem(key,JSON.stringify(saved)) : localStorage.removeItem(key); } catch (_) {} }
  // Compare only explicitly named model families. A family match never proves generation fitment.
  function modelConflict(value,carKey) {
    const models={'Model 3':['3'],'Model Y':['y'],'Model S':['s'],'Model X':['x'],'Model 3/Y':['3','y'],'Model 3 Highland':['3'],'Model Y Juniper':['y']};
    const name=value.replace(/^Tesla\s+/,'').trim();
    const families=models[name];
    if (!families) return false;
    if (!families.includes(carKey.split('-')[0])) return true;
    return (name==='Model 3 Highland' && carKey!=='3-highland') || (name==='Model Y Juniper' && carKey!=='y-juniper');
  }
  if (activeOption) persist();
  function sync() {
    for (const el of selectors) {
      el.querySelector('[data-vt-car]').value = saved?.key || '';
      el.querySelector('[data-vt-year]').value = saved?.year || '';
      el.querySelector('[data-vt-clear]').hidden = !saved;
      el.querySelector('[data-vt-saved]').textContent = saved ? `${carLabel()}${saved.year ? ' · '+saved.year : ''}` : '';
      el.dataset.hasCar = String(Boolean(saved));
      const action = el.querySelector('[data-vt-vehicle-action]');
      if (action) action.textContent = saved ? action.dataset.change : action.dataset.choose;
    }
    document.querySelectorAll('[data-vt-current-car]').forEach(el => { el.textContent = saved ? `${carLabel()}${saved.year ? ' · '+saved.year : ''}` : ''; });
    for (const box of document.querySelectorAll('[data-vt-fitment]')) {
      const status = box.querySelector('[data-vt-fitment-status]');
      const variantStatus=box.querySelector('[data-vt-variant-fitment]');
      const picker=box.closest?.('.shopify-section')?.querySelector('product-variant-selector');
      const selectedModel=picker?.dataset.selectedModel || '';
      if (variantStatus) {
        variantStatus.hidden=!saved || !selectedModel;
        const pending=picker?.getAttribute('aria-busy')==='true';
        const conflict=saved && selectedModel && modelConflict(selectedModel,saved.key);
        variantStatus.dataset.state=conflict?'mismatch':'unknown';
        variantStatus.textContent=pending?variantStatus.dataset.pending:(conflict?variantStatus.dataset.different:variantStatus.dataset.check).replace('__MODEL__',selectedModel);
      }
      if (!saved) { status.textContent = ''; delete box.dataset.state; continue; }
      let cars=[]; try { cars = JSON.parse(box.dataset.fitment)?.vehicles || []; } catch (_) {}
      if (!cars.length && box.querySelector('.vt-fitment-unknown')) {
        status.textContent = ''; delete box.dataset.state; continue;
      }
      const same = cars.filter(c => c.key === saved.key);
      const within = same.filter(c => !saved.year || ((!c.year_from || +saved.year >= c.year_from) && (!c.year_to || +saved.year <= c.year_to)));
      let state = !cars.length ? 'unknown' : !within.length ? 'mismatch' : !saved.year || within.some(c => !c.year_from) ? 'noYear' : 'match';
      status.textContent = box.dataset[state]; box.dataset.state = state;
      // A product-wide match cannot certify the selected model-specific variant.
      if (selectedModel) { status.textContent=''; delete box.dataset.state; }
    }
    for (const link of document.querySelectorAll('[data-choice-contact]')) {
      if (!link.dataset.inquiry) continue;
      const target=new URL(link.href);
      target.searchParams.set('product_inquiry',[link.dataset.inquiry,saved?`${carLabel()}${saved.year?' · '+saved.year:''}`:''].filter(Boolean).join('\n'));
      link.href=target.toString();
      link.closest('.shopify-section')?.querySelectorAll('[data-vt-product-inquiry]').forEach(help => {
        help.href = link.href;
      });
    }
    const carField=document.querySelector('input[name="contact[car_model_and_year]"]');
    if (carField && !carField.value && saved) carField.value=`${carLabel()} ${saved.year || ''}`.trim();
  }
  for (const el of selectors) {
    el.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      const model=el.querySelector('[data-vt-car]'),year=el.querySelector('[data-vt-year]');
      if (!event.target.reportValidity()) return;
      saved={key:model.value,year:year.value,label:model.selectedOptions[0].textContent.trim()};persist();sync();
      // Shopify performs filtering across the entire catalogue, including pagination.
      el.querySelector('[data-vt-save-status]').textContent=el.querySelector('[data-vt-save-status]').dataset.message;
      if (event.target.dataset.filterEnabled !== 'true') {
        el.open = false;
        el.querySelector('summary').focus();
        return;
      }
      const url=new URL(event.target.action);url.searchParams.set(param,model.selectedOptions[0].dataset.filter);
      location.assign(url.toString());
    });
    el.querySelector('[data-vt-clear]').addEventListener('click',()=>{
      saved=null;persist();sync();
      el.open = true;
      for (const item of selectors) item.querySelector('[data-vt-save-status]').textContent='';
      const url=new URL(location.href);
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);url.searchParams.delete('page');location.assign(url.toString());
      }
    });
  }
  sync();
  if (saved) selectors.forEach(el => { if (el.hasAttribute('data-vt-compact')) el.open = false; });
  document.addEventListener('vt:selection-changed',sync);
  document.querySelector('[data-vt-edit-search]')?.addEventListener('click', event => {
    const input = document.getElementById('VtSearchInput');
    if (!input) return;
    event.preventDefault();
    input.focus();
    input.select();
    input.scrollIntoView({block:'center'});
  });
  const jump=document.querySelector('[data-vt-buy-jump]');
  const buy=document.querySelector('.product-section product-form');
  if(jump && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries=>{jump.hidden=entries[0].isIntersecting;},{threshold:0}).observe(buy);
  }
  const body=document.querySelector('textarea[name="contact[body]"]');
  const inquiry=new URLSearchParams(location.search).get('product_inquiry');
  if(body && !body.value && inquiry) body.value=inquiry.slice(0,1200);
  for(const help of document.querySelectorAll('[data-vt-buy-help]')) {
    const section=help.closest('.shopify-section'),form=section?.querySelector('product-form');
    if(!form) continue;
    const link=help.querySelector('[data-vt-stock-link]');
    const update=()=>{
      const sold=form.querySelector('[data-sold-out-button]');
      link.hidden=!sold || sold.hidden || sold.hasAttribute('data-cart-limit-reached');
      const id=form.getAttribute('current-variant');
      const productURL=new URL(location.pathname,location.origin);if(id)productURL.searchParams.set('variant',id);
      const selected=[...section.querySelectorAll('product-variant-selector input:checked')].map(i=>i.value).join(' / ');
      const target=new URL(link.href);target.searchParams.set('product_inquiry',`${link.textContent.trim()}: ${document.querySelector('h1')?.textContent.trim() || ''}\n${selected}\n${productURL}`);link.href=target.toString();
    };
    new MutationObserver(update).observe(form,{attributes:true,subtree:true,attributeFilter:['hidden','current-variant','data-cart-limit-reached']});update();
  }
})();

(() => {
  const mobile = window.matchMedia('(max-width: 899px)');
  const boundPanels = new WeakSet();
  const boundForms = new WeakSet();
  const syncPanel = panel => {
    panel.open = !mobile.matches;
    panel.querySelectorAll('.vtc-filter').forEach(group => {
      group.open = !mobile.matches || Boolean(group.querySelector('input:checked, input[type="number"][value]'));
    });
  };
  function initFilters() {
    for (const panel of document.querySelectorAll('details.vtc-filters')) {
      if (boundPanels.has(panel)) continue;
      boundPanels.add(panel);
      syncPanel(panel);
    }
    for (const form of document.querySelectorAll('[data-vt-filter-form]')) {
      if (boundForms.has(form)) continue;
      boundForms.add(form);
      const min = form.querySelector('input[name="filter.v.price.gte"]');
      const max = form.querySelector('input[name="filter.v.price.lte"]');
      const error = form.querySelector('[data-vt-filter-error]');
      const clearError = () => {
        max?.setCustomValidity('');
        if (error) { error.hidden = true; error.textContent = ''; }
      };
      min?.addEventListener('input', clearError);
      max?.addEventListener('input', clearError);
      form.addEventListener('submit', event => {
        clearError();
        if (min?.value && max?.value && Number(min.value) > Number(max.value)) {
          event.preventDefault();
          const message = form.dataset.priceError;
          max.setCustomValidity(message);
          if (error) { error.textContent = message; error.hidden = false; }
          max.reportValidity();
          max.focus();
        }
      });
      form.addEventListener('formdata', event => {
        for (const [name,value] of [...event.formData]) {
          if (name.startsWith('filter.') && !value.trim()) event.formData.delete(name);
        }
      });
    }
  }
  initFilters();
  document.addEventListener('vt:results-updated', initFilters);
  document.addEventListener('shopify:section:load', initFilters);
  mobile.addEventListener?.('change', () => {
    document.querySelectorAll('details.vtc-filters').forEach(syncPanel);
  });
  const topic = new URLSearchParams(location.search).get('inquiry_topic');
  const body = document.querySelector('textarea[name="contact[body]"]');
  if (body && !body.value && ['order','return','damage'].includes(topic)) {
    body.value = body.getAttribute('data-topic-'+topic) || '';
  }
})();


(() => {
  const currentPath = location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.vtp-header nav a[href], .vtp-footer__links a[href]').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && !url.search && !url.hash && (url.pathname.replace(/\/$/, '') || '/') === currentPath) {
      link.setAttribute('aria-current', 'page');
    }
  });
  const topic = document.querySelector('[data-vt-contact-topic]');
  if (!topic) return;
  const params = new URLSearchParams(location.search);
  const requested = params.has('product_inquiry') ? 'product' : params.get('inquiry_topic');
  const selected = [...topic.options].find(option => option.dataset.topic === (requested === 'damage' ? 'return' : requested));
  if (!topic.value && selected) topic.value = selected.value;
  const form = topic.closest('form');
  const body = form?.querySelector('textarea[name="contact[body]"]');
  const help = form?.querySelector('[data-vt-topic-help]');
  const templates = ['order','return','damage'].map(value => body?.getAttribute('data-topic-'+value)).filter(Boolean);
  let automaticMessage = templates.includes(body?.value) ? body.value : '';
  const updateHelp = () => {
    const selectedTopic = topic.selectedOptions[0]?.dataset.topic;
    const message = help?.getAttribute('data-topic-'+selectedTopic) || '';
    if (help) { help.textContent = message; help.hidden = !message; }
  };
  topic.addEventListener('change', () => {
    updateHelp();
    if (!body || (body.value.trim() && body.value !== automaticMessage)) return;
    automaticMessage = body.getAttribute('data-topic-'+topic.selectedOptions[0]?.dataset.topic) || '';
    body.value = automaticMessage;
  });
  updateHelp();
})();

(() => {
  'use strict';
  const bound = new WeakSet();
  function initPackages() {
    for (const box of document.querySelectorAll('[data-vtpkg]')) {
      if (bound.has(box)) continue;
      bound.add(box);
      const form = box.querySelector('[data-vtpkg-form]');
      const model = box.querySelector('[data-vtpkg-model]');
      const install = box.querySelector('[data-vtpkg-install]');
      const confirm = box.querySelector('[data-vtpkg-confirm]');
      const button = box.querySelector('[data-vtpkg-add]');
      const status = box.querySelector('[data-vtpkg-status]');
      const root = box.dataset.root;
      const currency = window.Shopify?.currency?.active || 'EUR';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'fi', {style:'currency',currency});
      let selection = null, revision = 0, busy = false;
      const price = n => money.format(n / 100);
      const group = () => box.querySelector(`[data-vtpkg-group="${model.value}"]`);
      const say = text => { status.textContent = text; };
      const reset = () => {
        selection = null; button.disabled = true;
        box.querySelectorAll('[data-vtpkg-price], [data-vtpkg-total]').forEach(el => { el.textContent='—'; });
      };
      async function product(handle) {
        const response = await fetch(root+'products/'+encodeURIComponent(handle)+'.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error('product');
        const data = await response.json();
        if (!Array.isArray(data.variants)) throw new Error('variants');
        return data;
      }
      function variant(p, fitting) {
        const names = p.options.map(o => typeof o === 'string' ? o : o.name);
        const amount = names.indexOf('Määrä'), service = names.indexOf('Asennus');
        if (amount < 0 || service < 0) throw new Error('options');
        const v = p.variants.find(v => String(v['option'+(amount+1)])==='4' && v['option'+(service+1)]===(fitting?'Kyllä':'Ei'));
        if (!v || !Number.isInteger(v.price) || v.price<=0) throw new Error('variant');
        return v;
      }
      async function readSelection() {
        const tyreHandle = group().querySelector('[data-vtpkg-tyre]').value;
        const wheelHandle = box.dataset['wheel'+model.value.toUpperCase()];
        const wheel = box.getAttribute('data-wheel-'+model.value) || wheelHandle;
        const [t,w,s] = await Promise.all([product(tyreHandle),product(wheel),product(box.dataset.sensor)]);
        const t0=variant(t,false), t1=variant(t,install.checked), w0=variant(w,false), sensor=s.variants[0];
        if (!sensor || !Number.isInteger(sensor.price) || sensor.price<=0) throw new Error('sensor');
        const available=[t1,w0,sensor].every(v=>v.available===true);
        const amount=t1.price+w0.price+sensor.price*4;
        const signature=JSON.stringify([model.value,t1.id,t1.price,w0.id,w0.price,sensor.id,sensor.price,available]);
        return {tyre:t1,baseTyre:t0,wheel:w0,sensor,amount,signature,available,wheelProduct:w,tyreProduct:t,sensorProduct:s,tyreHandle,wheelHandle:wheel,model:model.selectedOptions[0].textContent};
      }
      function show(value) {
        selection=value;
        const amounts={tyre:value.baseTyre.price,wheel:value.wheel.price,sensor:value.sensor.price*4,installation:value.tyre.price-value.baseTyre.price};
        for (const [name,amount] of Object.entries(amounts)) box.querySelector(`[data-vtpkg-price="${name}"]`).textContent=price(amount);
        box.querySelector('[data-vtpkg-total]').textContent=price(value.amount);
        const link=box.querySelector('[data-vtpkg-wheel-link]');
        link.href=root+'products/'+value.wheelHandle;
        link.textContent=value.wheelProduct.title.split(' – ').pop();
        const tyreLink=box.querySelector('[data-vtpkg-tyre-link]');
        tyreLink.href=root+'products/'+value.tyreHandle;tyreLink.textContent=value.tyreProduct.title.split(' – ').pop();
        for(const [name,p] of Object.entries({tyre:value.tyreProduct,wheel:value.wheelProduct,sensor:value.sensorProduct})) {
          const parsed=new DOMParser().parseFromString(p.description,'text/html');
          const heading=[...parsed.querySelectorAll('h2')].find(h=>['saatavuus','availability','tillgänglighet','beschikbaarheid','tilgængelighed'].includes(h.textContent.trim().toLowerCase()));
          box.querySelector('[data-vtpkg-availability="'+name+'"]').textContent=heading?.nextElementSibling?.textContent || '';
        }
        button.disabled=!value.available || busy || !confirm.checked;
        say(value.available?'':box.dataset.unavailable);
      }
      async function refresh() {
        const n=++revision;
        confirm.checked=false;
        reset(); say(box.dataset.loading);
        for (const el of box.querySelectorAll('[data-vtpkg-group]')) el.hidden=el.dataset.vtpkgGroup!==model.value;
        try { const value=await readSelection(); if(n===revision) show(value); }
        catch (_) { if(n===revision) {reset();say(box.dataset.error);} }
      }
      model.addEventListener('change',refresh);
      install.addEventListener('change',refresh);
      box.querySelectorAll('[data-vtpkg-tyre]').forEach(el=>el.addEventListener('change',refresh));
      confirm.addEventListener('change',()=>{ button.disabled=busy || !selection?.available || !confirm.checked; });
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(busy || !selection?.available || !form.reportValidity()) return;
        busy=true; button.disabled=true; button.textContent=box.dataset.busy;
        form.querySelectorAll('select,input').forEach(el=>{el.disabled=true;});
        const expected=selection.signature, n=++revision;
        try {
          const value=await readSelection();
          if(n!==revision) return;
          if(value.signature!==expected) {
            show(value); confirm.checked=false; say(box.dataset.changed); return;
          }
          const packageKey='VT-'+Date.now().toString(36);
          const properties={Paketti:packageKey,Autoversio:value.model};
          const items=[{id:value.tyre.id,quantity:1,properties},{id:value.wheel.id,quantity:1,properties},{id:value.sensor.id,quantity:4,properties}];
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok || !Array.isArray(result.items) || result.items.length!==3) throw new Error('cart');
          confirm.checked=false;
          box.querySelector('[data-vtpkg-cart]').hidden=false;
          say(box.dataset.added);
        } catch (_) { say(box.dataset.error); }
        finally { form.querySelectorAll('select,input').forEach(el=>{el.disabled=false;});busy=false; button.textContent=box.dataset.add;button.disabled=!selection?.available || !confirm.checked; }
      });
      refresh();
    }
  }
  initPackages();
  document.addEventListener('shopify:section:load',initPackages);
})();
